<template>
  <Block badge-class="bg-blue-50" :emoji="emoji" :title="title" :subtitle="subtitle">
    <div
      class="overflow-x-auto overflow-y-auto border-t border-gray-100 max-h-56 sm:max-h-48"
      v-if="formattedSellersRanking.length > 0"
      ref="tableContainer"
    >
      <Table :columns="columns" :data="formattedSellersRanking">
        <template #rank="{ row }">
          <div
            class="w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs"
            :class="row.isCurrent ? 'bg-purple-200 text-purple-800' : getMedalClass(row.rank)"
          >
            {{ row.rank }}
          </div>
        </template>

        <template #name="{ row }">
          <div class="flex flex-col sm:block">
            <h4
              class="text-sm font-semibold flex items-center gap-1 leading-none"
              :class="row.isCurrent ? 'text-purple-700' : 'text-gray-900'"
            >
              <span>{{ row.name }}</span>
            </h4>
            <p class="text-xs" :class="row.isCurrent ? 'text-purple-600' : 'text-gray-500'">
              {{ row.store }}
            </p>
            <!-- Nombre de ventes sous le nom sur mobile -->
            <p class="mt-1 text-sm font-bold sm:hidden" :class="row.isCurrent ? 'text-purple-700' : 'text-gray-600'">
              {{ $t("roadmap.sales", row.sales) }}
            </p>
          </div>
        </template>

        <template #sales="{ row }">
          <p class="hidden sm:block text-sm font-bold" :class="row.isCurrent ? 'text-purple-700' : 'text-gray-600'">
            {{ $t("roadmap.sales", row.sales) }}
          </p>
        </template>
      </Table>
    </div>
    <div v-else class="flex items-center justify-center p-4 border-t border-gray-100">
      <p class="text-sm text-gray-600">
        Réalisez votre première vente du mois pour voir votre classement s’animer. Chaque vente compte — à vous de jouer
        !
      </p>
    </div>
  </Block>
</template>

<script>
import { Table, Block, formatPrice, computeCompetitionRanking } from "@estaly/ui";
import { scrollToCurrentItem } from "@/utils/scroller";

export default {
  components: {
    Block,
    Table,
  },
  props: {
    sellersRanking: {
      type: Array,
      required: true,
    },
    currentSellerIds: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "Classement vendeur",
    },
    subtitle: {
      type: String,
      default: "",
    },
    emoji: {
      type: String,
      default: "🏪",
    },
  },
  computed: {
    formattedSellersRanking() {
      return computeCompetitionRanking(this.sellersRanking, "totalRetributions").map((sellerRanking) => {
        const isCurrent = this.currentSellerIds.includes(sellerRanking.seller.id);
        return {
          rank: sellerRanking.rank,
          sellerId: sellerRanking.seller.id,
          name: sellerRanking.seller.name,
          sales: sellerRanking.totalRetributions,
          leadsWaiting: sellerRanking.leadsWaitingForConfirmation || 0,
          store: sellerRanking.salesChannel,
          isCurrent,
          rowClass: isCurrent ? "bg-purple-50" : "",
        };
      });
    },
    columns() {
      return [
        {
          label: null,
          field: "rank",
          slot: "rank",
          widthClass: "w-12",
        },
        {
          label: null,
          field: "name",
          slot: "name",
        },
        {
          label: null,
          field: "sales",
          slot: "sales",
          numeric: true,
          widthClass: "w-20",
        },
      ];
    },
  },
  mounted() {
    this.scrollToCurrentSeller();
  },
  watch: {
    formattedSellersRanking() {
      this.$nextTick(() => {
        this.scrollToCurrentSeller();
      });
    },
  },
  methods: {
    formatPrice,
    getMedalClass(ranking) {
      if (ranking === 0) return;

      const classes = [
        "bg-linear-to-r/srgb from-yellow-400 to-yellow-500 text-white",
        "bg-linear-to-r/srgb from-gray-300 to-gray-400 text-white",
        "bg-linear-to-r/srgb from-orange-400 to-orange-800 text-white",
      ];
      return classes[ranking - 1] || "bg-gray-100 text-gray-600";
    },
    scrollToCurrentSeller() {
      this.$nextTick(() => {
        if (!this.$refs.tableContainer) return;
        scrollToCurrentItem(this.$refs.tableContainer, this.formattedSellersRanking, (seller) => seller.isCurrent);
      });
    },
  },
};
</script>
